import React, {useContext, useMemo} from 'react';


import {UserLink} from 'src/components/links';
import {Skeleton, SkeletonItem} from 'src/components/skeleton';
import {useGetUserShortInfo} from 'src/hooks/useGetUserShortInfo';
import {getUserLabel} from 'src/utils/getUserLabel';
import {mapDateFormat} from 'src/utils/mapDateFormat';

import {FormattedDate} from '@pb/kit-component-formatters';
import {LocaleContext} from '@pb/kit-context-locale';

type Props = {
    editorId: number,
    lastEdited: string,
};

export const LastEditedLabel = ({editorId, lastEdited}: Props) => {
    const {isLoading, data} = useGetUserShortInfo({userId: editorId});
    const {locale} = useContext(LocaleContext);

    const link = useMemo(() => (
        <UserLink
            blank={true}
            userId={data.userId}
            caption={getUserLabel(data)}
            place="FullStory Configurator"
        />
    ), [data]);

    return (
        <Skeleton shown={isLoading} view={<SkeletonItem width={284} height={16}/>}>
            <span>Last edit by {link} on {FormattedDate.format({
                value: lastEdited,
                format: mapDateFormat(locale.dateFormat, 'WORD', 'DATE_TIME'),
            })}
            </span>
        </Skeleton>
    );
};
